<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="流转箱管理"
    size="560px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <div class="search-from">
        <div>
          <el-button
            v-if="enable"
            type="primary"
            @click="addtagapply">生产流转箱码</el-button>
          <el-button
            v-if="enable"
            type="primary"
            @click="downloadFile">下载流转箱码</el-button>
        </div>
        <!-- <el-input
          v-model="config.countryName"
          style="width: 240px"
          clearable=""
          placeholder="请输入原产国名称">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <el-button
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="序号"
          width="100"
          prop="boxNo"></el-table-column>
        <el-table-column
          label="箱码"
          min-width="100"
          prop="boxNumber"></el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: center;"
        :current-page="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <box-code-download-modal ref="download" />
  </el-drawer>
</template>
<script>
import Wms from '@/service/wms'
import BoxCodeDownloadModal from './box-code-download-modal.vue'
export default {
  name: 'BoxCodeModal',
  components: { BoxCodeDownloadModal },
  props: {
    enable: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10 },
      list: [],
      total: 0
    }
  },
  methods: {
    downloadFile() {
      this.$refs.download.init({ endBoxNo: this.total })
    },
    addtagapply() {
      this.$prompt('请输入生产数量', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /^[1-9]\d*$/, inputErrorMessage: '请输入正整数',
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            Wms.createappraisaltransferbox({ num: instance.inputValue })
              .then(res => {
                this.loading = false
                const { result, message } = res.data
                if ([0].includes(result)) {
                  this.$message.success('生产流转箱码成功')
                  done()
                  this.fetchList()
                } else {
                  this.$message.error(message)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
          }
        }
      })
    },
    onClosed() {
      this.config.pageNum = 1
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getappraisaltransferboxs({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch() {
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
